module.exports = "/_next/static/images/6fb285bd836bfb05b2f840cee0b02cc8-secured-icon-lg.svg";